import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ConfigurationWizard } from "@/components/configurations/ConfigurationWizard";
import ErrorDisplay from "@/components/ErrorDisplay";
import * as policiesApi from "@/services/policiesApi";

export default function EditProfilePage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: policy, isLoading, error } = useQuery({
    queryKey: ["policy", id],
    queryFn: () => policiesApi.getPolicy(id!),
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <div className="container mx-auto py-8 px-4">
        <div className="h-8 w-48 bg-muted rounded animate-pulse mb-8" />
        <div className="border rounded-lg p-6 space-y-4">
          <div className="h-6 w-2/3 bg-muted rounded animate-pulse" />
          <div className="h-4 w-full bg-muted rounded animate-pulse" />
          <div className="h-4 w-1/2 bg-muted rounded animate-pulse" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto py-8 px-4">
        <ErrorDisplay error={error} />
      </div>
    );
  }

  if (!policy) {
    return (
      <div className="container mx-auto py-8 px-4">
        <div className="text-center py-8">
          <h2 className="text-xl font-semibold">Configuration not found</h2>
          <p className="mt-2 text-muted-foreground">The requested configuration could not be found.</p>
        </div>
      </div>
    );
  }

  return <ConfigurationWizard editMode editId={id} initialData={policy} />;
}
